<template>
  <td :class="{isExist: isExist}">
    <input type="text" class="input"
      @focus="onFocus = true"
      @blur="onFocus = false"
      v-model="cate.label" />
    <p v-if="isExist && onFocus" class="colorRed mt5">{{locale.admin_code_exist}}</p>
    <div class="btns">
      <button class="btn btnRed sizeXs btnDel" @click="onOpenDelete">{{locale.delete}}</button>
    </div>
    <Delete
      v-if="layer"
      :locale="locale"
      @close="onCloseDelete"
      @delete="deleteItem(cate.id)" />
  </td>
</template>

<script>
import Delete from '@/components/Admin/SubmitCategoryDelete.vue'

export default {
  name: 'SubmitCategoryItem',
  props: [
    'locale',
    'existCate',
    'cate'
  ],
  components: {
    Delete
  },
  computed: {
    isExist () {
      const label = this.cate.label
      return this.existCate.includes(label)
    }
  },
  data () {
    return {
      onFocus: false,
      layer: false
    }
  },
  methods: {
    onOpenDelete () {
      this.layer = true
    },
    onCloseDelete () {
      this.layer = false
    },
    deleteItem (id) {
      this.$emit('delItem', id)
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  position: relative;
  &.isExist .input {
    color: $color-red;
    opacity: 0.7;
  }
  .input {
    width: 50%;
    min-height: 0;
    padding: 0.5em 1em;
    border-color: transparent;
    background-color: transparent;
    opacity: 0.5;
    &:focus {
      opacity: 1;
      border-color: $color-lgrey2;
    }
  }
  .btns {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);
    .btn {
      margin-left: 5px;
    }
  }
}
</style>